import { Device, Geotab, User } from "@fairfleet/geotab";

export default function confirmAccident(
  geotabClient: Geotab,
  diagnosticId: string,
  ruleId: string,
  me: User,
  device: Device,
  eventId: string,
  valid: boolean,
) {
  const payload = {
    deviceId: device.id,
    deviceName: device.name,
    deviceSerialNumber: device.serialNumber,
    diagnosticId,
    ruleId,
    targetId: eventId,
    securityGroups: me.securityGroups,
    userId: me.id,
    responses: [
      {
        answer: valid ? "Yes" : "No, dismiss event",
      },
    ],
  };
  return geotabClient.call("GetActiveInsights", {
    customerData: true,
    functionName: "insert-feedback",
    functionParameters: {
      applicationId: diagnosticId,
      payload: JSON.stringify(payload),
      sourceId: "Collision Detection",
    },
    serviceName: "dna-feedback-loop",
  });
}
